var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data && _vm.data.text)?_c('div',{class:{
    'ua-corner-lb': true,
    'ua-corner-lb--abs-pst': _vm.absPosition,
    'ua-corner-lb--mini': _vm.mini
  },style:(_vm.ctrStyles)},[_vm._v("\n  "+_vm._s(_vm.data.text)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }